var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownloadCloud = function SvgDownloadCloud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M31.58 18.52c-.728-5.736-5.642-10.186-11.573-10.186-4.594 0-8.584 2.685-10.405 6.916-3.58 1.07-6.262 4.45-6.262 8.084 0 4.595 3.738 8.333 8.333 8.333h1.667v-3.334h-1.667c-2.756 0-5-2.243-5-5 0-2.34 1.999-4.594 4.455-5.026l.969-.17.32-.93c1.171-3.418 4.08-5.54 7.59-5.54 4.595 0 8.333 3.738 8.333 8.333v1.667h1.667A3.337 3.337 0 0 1 33.34 25a3.337 3.337 0 0 1-3.333 3.334h-3.334v3.333h3.334A6.673 6.673 0 0 0 36.673 25a6.68 6.68 0 0 0-5.093-6.48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.673 23.333v-6.666H18.34v6.666h-5l6.667 8.334 6.666-8.334z"
  })));
};
export default SvgDownloadCloud;